export const CONFIRMED_CREATE_SYMPTOM_MEDICINE_MAPPING_ACTION = "CONFIRMED_CREATE_SYMPTOM_MEDICINE_MAPPING_ACTION";
export const CONFIRMED_DELETE_SYMPTOM_MEDICINE_MAPPING_ACTION = "CONFIRMED_DELETE_SYMPTOM_MEDICINE_MAPPING_ACTION";
export const CONFIRMED_EDIT_SYMPTOM_MEDICINE_MAPPING_ACTION = "CONFIRMED_EDIT_SYMPTOM_MEDICINE_MAPPING_ACTION";
export const CONFIRMED_GET_SYMPTOM_MEDICINE_MAPPINGS = "CONFIRMED_GET_SYMPTOM_MEDICINE_MAPPINGS";
